import { ajaxRequest } from "../../Utils/Ajax/ajax";
import { showResults } from "./Results";


export function loadResults(testNr){
    $("#main-wrapper").prepend('<div class="preloader" style="display: block;">' +
   '<div class="spinner-border text-primary tea lds-ripple" role="status">' +
   '    <span class="sr-only">Loading...</span>' +
   '</div>' +
    '</div>');

    const url = '/submission/' + testNr.toString() + '/result'
    
    const success = function (data){
        $(".preloader").fadeOut('fast');
        insertIntoResult(data)
    }
    
    return ajaxRequest(url, success);

}

export function loadResultWithData(data){
    insertIntoResult(data);
}

function insertIntoResult(data){
    showResults(data.answers, data.times, data.test.show_note, data.test.show_time_analysis, data.created_at);
}
